<template>
  <div class="desp">
    <div class="desp-header">Refund Information</div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Apply Reason</div>
      <div class="desp-item">
        <div class="desp-item-self danger">{{ detail.applyReason || "" }}</div>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Amount</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="lh18 desp-item-label">
                <span class="mr8">Total Due</span>
                <br />
                <span class="fs12">(Excl. Tax)</span>
              </div>
              <div class="lh18 desp-item-content">
                <span class="orange">
                  {{ currencyAndAmountFormat(detail.billingCurrency, detail.refundAmountExclTax) }}
                </span>
                <br />
                <span v-if="$isNumberLike(detail.refundAmountCnyExclTax)">{{ symbolAndAmountFormat("¥", detail.refundAmountCnyExclTax) }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Gov Fee</div>
              <div class="desp-item-content">
                <span class="orange">
                  {{ currencyAndAmountFormat(detail.billingCurrency, detail.deductionAcraFee) }}
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Handling Fee</div>
              <div class="desp-item-content">
                <span class="orange">
                  {{ currencyAndAmountFormat(detail.billingCurrency, detail.deductionHandlingFee) }}
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Information</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Transaction No.</div>
              <div class="desp-item-content">{{ detail.businessNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund Status</div>
              <div class="desp-item-content">
                {{ refundStatusFormat(detail.status) }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund No.</div>
              <div class="desp-item-content">
                {{ detail.refundNo || "" }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Create Time</div>
              <div class="desp-item-content">{{ detail.createTime }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="desp-items-group" v-if="detail.failReason">
      <div class="desp-items-group-title">Fail Reason</div>
      <div class="desp-item">
        <div class="desp-item-self danger">{{ detail.failReason || "" }}</div>
      </div>
    </div>
    <div class="desp-items-group">
      <div class="desp-items-group-title">Operator</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Refund Teller</div>
              <div class="desp-item-content">
                {{ detail.refundingTeller?.nickname || detail.refundingTeller?.username || "" }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Apply Time</div>
              <div class="desp-item-content">
                {{ detail.applyTime || "" }}
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Finish Time</div>
              <div class="desp-item-content">
                {{ detail.finishTime || "" }}
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 发票 -->
    <div class="desp-items-group">
      <div class="desp-items-group-title">Generic Invoice</div>
      <div class="desp-item">
        <div class="desp-item-self">
          <span class="mr40 to-link" @click="invoiceLink(detail.customerInvoice?.invoiceNumber)" v-if="detail.customerInvoice?.invoiceType == 1">
            Invoice
          </span>
          <span class="to-link" @click="invoiceLink(detail.customerInvoice?.invoiceNumber)" v-if="detail.customerInvoice?.invoiceType == 2">
            Credit Invoice
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dataListLoading: false,
    };
  },
  methods: {
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";
.to-link {
  cursor: pointer;
  color: #{$--color-primary};
}
</style>
